import type { PromoteFormState } from './types';

export type InitialStateParams = {
	amount: number;
	name: string;
	firstName: string;
	lastName: string;
	shouldSavePaymentMethod: boolean;
	isPublic: boolean;
};

export function initialState({
	amount,
	name,
	firstName,
	lastName,
	shouldSavePaymentMethod,
	isPublic,
}: InitialStateParams): PromoteFormState {
	return {
		amount,
		formState: { status: 'ready' },
		firstName,
		lastName,
		name,
		isPublic,
		paymentMethodSaveOptions: {
			shouldSavePaymentMethod,
			usage: 'ON_SESSION',
		},
		validationErrors: null,
		customAmountSelected: false,
		moreWaysExpanded: false,
		promoteFormRevealed: false,
	};
}
